// Common
import { Inject, Injector, Optional, Pipe, untracked, type PipeTransform, type Signal } from '@angular/core';
import { listWorkspaceScope } from '@modules/common/components/item-workspace/list-workspace-scope';
import { checkExhaustiveness } from '@modules/common/utils/switch';

// Types
import { VirtualFolder } from '@modules/files/types/virtual-folder';

@Pipe({
  name: 'titleByFilesFilter',
  standalone: false,
  pure: false,
})
export class TitleByFilesFilterPipe implements PipeTransform {
  private workspaceScope?: Signal<'team' | 'mine' | undefined>;

  public constructor(@Optional() @Inject(Injector) private readonly injector: Injector | null = null) {}

  public transform(value: VirtualFolder, containerName?: string | null, nameWorkspace = false): string {
    const injector = this.injector;
    if (nameWorkspace && value === 'all_files' && injector) {
      this.workspaceScope ??= untracked(() => listWorkspaceScope(injector));
      const workspace = this.workspaceScope();
      if (workspace) return `${workspace === 'team' ? 'Team' : 'My'} Files`;
    }
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'search_results':
        return 'All Results';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'following':
        return 'Following';
      case 'assigned_to_me':
        return 'Assigned to me';
      case 'all_files':
        return 'Files';
      case 'flagged':
        return 'Flagged';
      case 'followed':
        return 'Follow up';
      case 'all_folders':
        return 'Folders';
      case 'snoozed':
        return 'Snoozed';
      default:
        return checkExhaustiveness(value);
    }
  }
}
